module.exports = new __parcel__URL__("cmgtlogo.989b7f28.webp").toString();